import styled from 'styled-components';

export const DisableBadge = styled.span`
    & * {
        filter: ${(props) => (props.isActive ? 'grayscale(1)' : null)};
    }
`;